export default __webpack_public_path__ + "static/media/class.97cd7574.jpg";